const isPlaceholderImage = (imageUrl = "") => imageUrl.indexOf("dealers") === -1;
export default isPlaceholderImage;
